import cx from "classnames";

import { Logo } from "../Logo";
import { HeaderStyleProps } from "./Header";
import header from "./header.module.css";

export const LogoHeader = ({ inverse, overlay }: HeaderStyleProps) => (
  <header
    className={cx(header.header, {
      [header.inverse]: inverse,
      [header.overlay]: overlay,
    })}
  >
    <Logo className={header.logo} />
  </header>
);
